<div class="row-1">
	<h2 class="title">{{ dashboardName() }}</h2>
	<ng-content select=".cl-header-subtitle"></ng-content>
	<div class="row-1-utility">
		<ng-content select=".cl-header-utility"></ng-content>
	</div>
</div>
<div class="row-2">
	<ng-content></ng-content>
</div>
